import { motion } from "framer-motion";
import { Check, CreditCard } from "lucide-react";
import { startCheckout } from "../lib/payments";

const PACKS = [
  {
    lookup: "pack_ponctuel",
    testid: "pack-card-ponctuel",
    buyTestid: "pack-buy-ponctuel",
    name: "Ménage Ponctuel",
    price: "90 €",
    period: "l'intervention",
    desc: "Un grand coup de propre, quand vous en avez besoin.",
    features: ["Logement jusqu'à 80 m²", "Pièces de vie, cuisine, sanitaires", "Produits éco-responsables fournis"],
  },
  {
    lookup: "pack_hebdo_mensuel",
    testid: "pack-card-hebdo",
    buyTestid: "pack-buy-hebdo",
    name: "Pass Hebdomadaire",
    price: "250 €",
    period: "/mois",
    tag: "Le plus choisi",
    desc: "Un passage chaque semaine, l'esprit tranquille.",
    features: ["1 intervention par semaine", "Même intervenant dédié", "Priorité planning & report flexible"],
  },
  {
    lookup: "pack_vitres",
    testid: "pack-card-vitres",
    buyTestid: "pack-buy-vitres",
    name: "Vitres & Façades",
    price: "120 €",
    period: "l'intervention",
    desc: "Une transparence parfaite, sans trace.",
    features: ["Baies vitrées & vérandas", "Vitrines de commerce", "Intérieur + extérieur"],
  },
];

export const Packs = () => (
  <section id="packs" data-testid="packs-section" className="py-28 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">Packs & réservation en ligne</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-2xl">
          Réservez et payez <span className="text-amber-300">en 2 minutes</span>, en toute sécurité
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {PACKS.map((p, i) => (
          <motion.div
            key={p.lookup}
            data-testid={p.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.1 }}
            className={`relative rounded-3xl border p-8 flex flex-col transition-all duration-500 hover:scale-[1.02] ${
              p.tag
                ? "border-amber-400/50 bg-gradient-to-b from-amber-400/[0.08] to-transparent shadow-[0_0_50px_rgba(242,193,78,0.12)]"
                : "border-white/10 bg-[#111723]/75 card-glow hover:border-amber-400/30"
            }`}
          >
            {p.tag && (
              <span className="absolute -top-3 left-8 text-[10px] uppercase tracking-[0.2em] font-bold text-[#0A0D14] bg-amber-400 rounded-full px-3 py-1">
                {p.tag}
              </span>
            )}
            <h3 className="font-display text-xl font-semibold text-white">{p.name}</h3>
            <p className="mt-1 text-sm text-slate-400">{p.desc}</p>
            <p className="mt-6 font-display text-4xl font-extrabold text-white">
              {p.price} <span className="text-sm font-medium text-slate-400">{p.period}</span>
            </p>
            <ul className="mt-6 space-y-2.5 flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
                  <Check className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" /> {f}
                </li>
              ))}
            </ul>
            <button
              data-testid={p.buyTestid}
              onClick={() => startCheckout(p.lookup)}
              className={`mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full py-3.5 text-sm font-bold transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] ${
                p.tag
                  ? "bg-amber-400 text-[#0A0D14] hover:shadow-[0_0_35px_rgba(242,193,78,0.45)]"
                  : "border border-amber-400/50 text-amber-200 hover:bg-amber-400/10"
              }`}
            >
              <CreditCard className="w-4 h-4" /> Réserver ce pack
            </button>
          </motion.div>
        ))}
      </div>

      <p className="mt-8 text-center text-xs text-slate-500">
        Paiement sécurisé par Stripe · TVA calculée automatiquement · Aucun prélèvement sans confirmation
      </p>
    </div>
  </section>
);
